<template>
  <div
    @paste="paste"
    v-loading="loading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="quill_editor-wrapper"
  >
    <div v-if="!disabled">
      <QuillEditor
        ref="myEditor"
        v-model="invalue"
        :options="options"
        @change="change"
      />
    </div>
    <div v-if="disabled" class="ql-editor ql-blank">
      <div class="ql-container" v-html="invalue" />
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor as QuillEditor } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
export default {
  components: { QuillEditor },
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      invalue: '',
      options: {
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { script: 'sub' },
            { script: 'super' },
            { color: [] },
            { background: [] },
            { size: ['small', false, 'large', 'huge'] },
          ],
        },
      },
      loading: false,
    }
  },
  watch: {
    value(val) {
      this.invalue = val
    },
    invalue() {
      this.$emit('input', this.invalue)
      this.$emit('update:value', this.invalue)
    },
  },
  created() {
    this.invalue = this.value
  },
  methods: {
    async paste(event) {
      if (this.disabled) return
      const items = (event.clipboardData || window.clipboardData).items
      if (!items?.length) return

      const files = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.type.indexOf('image') !== -1) {
          files.push(item.getAsFile())
        }
      }
      if (!files?.length) return

      event.preventDefault()

      this.loading = true
      const fileItems = await this.uploadFiles(files)
      const fileUrls = fileItems.filter(Boolean).map((item) => item.fileUrl)
      this.loading = false
      if (!fileUrls?.length) return

      const $editor = this.$refs.myEditor
      const quill = $editor.quill

      const cursorIndex = quill.getSelection().index

      fileUrls.forEach((url, index) => {
        quill.insertEmbed(cursorIndex + index, 'image', url)
        quill.setSelection(cursorIndex + index + 1)
      })
    },
    uploadFiles(files) {
      if (!files?.length) return Promise.resolve([])
      const uploadTask = files.map((file) => {
        return this.$api
          .SYS_UPLOAD(file)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    change({ html }) {
      if (!html) return
      const val = html.replaceAll('class="el-image__inner"', '')
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ql-container {
    min-height: 200px;
    max-height: 400px;
    overflow: auto;
  }
}
</style>
